import { Service } from '@angular/core';
import { loadStripe } from '@stripe/stripe-js';

@Service()
export class StripeLoaderService {
  async verifyIdentity(publishableKey: string, clientSecret: string): Promise<void> {
    const stripe = await loadStripe(publishableKey);

    if (!stripe) {
      throw new Error('Failed to load Stripe.js');
    }

    const { error } = await stripe.verifyIdentity(clientSecret);

    if (error) {
      throw new Error(error.message);
    }
  }
}
